import React from "react";

const markup = String.raw`<div class="overlay" id="s360overlay" onclick="if(event.target===this) closeS360()">
<div class="s360">
<div class="s360-head">
<div><div class="s360-name" id="s360name">AHB Pharma</div><div class="s360-meta" id="s360meta">Vendor ID VMS-0142 · Medicine category · Active since 2019</div></div>
<button class="s360-close" onclick="closeS360()">✕</button>
</div>
<div class="s360-tabs">
<button class="s360-tab active" data-p="overview" onclick="s360tab('overview',this)">Overview</button>
<button class="s360-tab" data-p="performance" onclick="s360tab('performance',this)">Performance</button>
<button class="s360-tab" data-p="risk" onclick="s360tab('risk',this)">Risk</button>
<button class="s360-tab" data-p="documents" onclick="s360tab('documents',this)">Documents</button>
</div>
<div class="s360-body">
<div class="s360-panel active" id="p-overview">
<div class="s360-kpis">
<div class="s360-kpi"><div class="l">YTD spend</div><div class="v" id="s360Spend">₹18.4L</div></div>
<div class="s360-kpi"><div class="l">Performance score</div><div class="v" id="s360Score">88 / 100</div></div>
<div class="s360-kpi"><div class="l">Active POs</div><div class="v">7</div></div>
<div class="s360-kpi"><div class="l">On-time delivery</div><div class="v" id="s360OTD">94%</div></div>
</div>
<table><tr><th>PO number</th><th>Item</th><th>Amount</th><th>Status</th></tr>
<tr><td>PO1023</td><td>Carmozyme 250mg</td><td>₹45,000</td><td><span class="pill amber">Pending</span></td></tr>
<tr><td>PO1019</td><td>Analgesic Syrup</td><td>₹22,300</td><td><span class="pill blue">In transit</span></td></tr>
<tr><td>PO1011</td><td>Antibiotic Cap 500</td><td>₹61,800</td><td><span class="pill green">Delivered</span></td></tr>
</table>
</div>
<div class="s360-panel" id="p-performance">
<div class="chart-wrap inline-style-18"><canvas aria-label="Line chart of vendor performance score over the last 6 months" id="chS360Perf" role="img"></canvas></div>
</div>
<div class="s360-panel" id="p-risk">
<div class="risk-badges">
<div class="risk-badge inline-style-54"><b>Financial</b>Low risk</div>
<div class="risk-badge inline-style-55"><b>Delivery</b>Medium risk</div>
<div class="risk-badge inline-style-54"><b>Compliance</b>Low risk</div>
<div class="risk-badge inline-style-54"><b>Quality</b>Low risk</div>
</div>
<p class="inline-style-56">Delivery risk flagged due to 2 late shipments last quarter, both linked to a raw-material shortage the vendor disclosed proactively.</p>
</div>
<div class="s360-panel" id="p-documents">
<div class="doc-row"><span>GST registration certificate</span><span class="pill green">Valid</span></div>
<div class="doc-row"><span>Drug manufacturing license</span><span class="pill green">Valid</span></div>
<div class="doc-row"><span>ISO 9001 certification</span><span class="pill amber">Expires in 18 days</span></div>
<div class="doc-row"><span>Bank verification letter</span><span class="pill green">Valid</span></div>
</div>
</div>
</div>
</div>`;

export default function Supplier360() {
  return (
    <div
      className="raw-fragment"
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}
